<div class="modal-customized request-form">
  <div class="modal-title">
    <h3>
      <!-- <span class="icon-view-details"></span> -->
      <i class="fa-solid fa-pencil"></i>
      {{ this.data.modal.title }}
    </h3>
    <span class="fa fa-times modal-close" (click)="closeDialog()" data-dismiss="modal"></span>
  </div>
  <div class="modal-content">
    <div class="controls">
      <div class="to-left">
        <!-- Empty -->
      </div>
      <div class="to-right">
        <p class="required"><i>*</i>Required fields</p>
      </div>
    </div>
    <div class="inputs-control">
      <div
        *ngFor="let select of data.modal.select; let i = index"
        class="select"
        [attr.rowspan]="i === 0 ? 2 : 1"
        [attr.id]="formatarId(select.title)"
      >
        <mat-form-field class="setup-field" appearance="outline">
          <mat-label>{{ select.title }}</mat-label>
          <mat-select
            [(ngModel)]="select.selectedOption"
            (ngModelChange)="onValueChange($event, select.title); onSelectChange()"
            [disabled]="
              select.disabled ||
              (select?.title?.toLowerCase() == 'process owner' && owners?.length < 0) ||
              (select?.title?.toLowerCase() == 'process owner' && owners?.length == null)
            "
            required
          >
            <ng-container
              *ngIf="select?.title?.toLowerCase() != 'process owner' && select?.title?.toLowerCase() != 'priorities'"
            >
              <mat-option *ngFor="let option of select.options" [value]="option.value">
                {{ option.label }}
              </mat-option>
            </ng-container>
            <mat-select-trigger *ngIf="select?.title?.toLowerCase() == 'priorities'" class="trigger-priorities">
              <i [class]="selectIcon + ' adjust-icon'" aria-hidden="true"></i>
              <p class="priority-select adjust-text">{{ selectText }}</p>
            </mat-select-trigger>
            <ng-container *ngIf="select?.title?.toLowerCase() == 'priorities'">
              <mat-option
                *ngFor="let option of select.options"
                [value]="option.value"
                (click)="changePriority(option); selectText = option.label"
              >
                <i [class]="option.icon" aria-hidden="true"></i>{{ option.label }}
              </mat-option>
            </ng-container>
            <ng-container
              *ngIf="
                select?.title?.toLowerCase() == 'process owner' &&
                owners?.length > 0 &&
                select?.title?.toLowerCase() != 'priorities'
              "
            >
              <mat-option *ngFor="let option of owners" [value]="option.value">
                {{ option.label }}
              </mat-option>
            </ng-container>
          </mat-select>
          <mat-error *ngIf="!select.selectedOption">* This select is required</mat-error>
        </mat-form-field>
      </div>
      <div
        *ngFor="let field of data.modal.fields; let i = index"
        class="fields"
        [attr.rowspan]="i === 0 ? 2 : 1"
        [attr.id]="formatarId(field.title)"
      >
        <mat-form-field
          class="setup-field"
          appearance="outline"
          [ngClass]="{
            'request-name-error': field.value && field.title === 'Request Name' && requestNameError.length > 0
          }"
          (keyup)="requestNameError = ''"
        >
          <mat-label>{{ field.title }}</mat-label>
          <input
            matInput
            [type]="field.title.toLowerCase() === 'estimated deadline' ? 'number' : 'text'"
            placeholder="{{ field.title }}"
            [(ngModel)]="field.value"
            (ngModelChange)="onInputChange()"
            [disabled]="field.disabled"
            [minlength]="field.title === 'Short Name' ? 3 : null"
            [maxlength]="field.title === 'Short Name' ? 3 : null"
            required
          />
          <mat-error *ngIf="field.title === 'Short Name' && field.value && field.value?.length < 3"
            >* This field is mandatory and requires 3 characters</mat-error
          >
          <mat-error *ngIf="!field.value && field.title !== 'Short Name'">* This field is required</mat-error>
          <mat-hint
            class="mat-error"
            *ngIf="field.value && field.title === 'Request Name' && requestNameError.length > 0"
            >{{ requestNameError }}</mat-hint
          >
        </mat-form-field>
      </div>

      <div *ngFor="let toggle of data.modal.toggles" class="slide-div">
        <span>{{ toggle.title }}</span>
        <mat-slide-toggle class="custom-slide-toggle" [disabled]="toggle.disabled" [(ngModel)]="toggle.value"
          >ACTIVE
        </mat-slide-toggle>
      </div>
    </div>
  </div>
</div>
<div class="actions">
  <div class="label-actions" mat-dialog-actions>
    <div class="creation">
      <!-- <span *ngFor="let label of data.modal.labels">{{label.title}}: <b>{{label.value}}</b></span> -->
    </div>
  </div>
  <div *ngIf="!editMode" class="btn-actions" mat-dialog-actions>
    <button
      *ngFor="let btnEdit of data.modal.button_edit"
      (click)="alertsSweet(btnEdit)"
      [disabled]="(btnEdit.title === 'Save' && !isShortNameValid()) || compareAcess(btnEdit?.required)"
      class="{{ btnEdit.class }}"
      mat-stroked-button
      color="primary"
    >
      <mat-icon *ngIf="btnEdit.class === 'button-edit'">edit</mat-icon> {{ btnEdit.title }}
    </button>
  </div>
  <div *ngIf="editMode" class="btn-actions" mat-dialog-actions>
    <button
      *ngFor="let btnEdit of this.action"
      (click)="alertsSweet(btnEdit)"
      class="{{ btnEdit.class }}"
      mat-stroked-button
      color="primary"
      [ngClass]="{ disabled: isSelectFilled && isInputFilled }"
      [disabled]="isSelectFilled && isInputFilled"
    >
      {{ btnEdit.title }}
    </button>
  </div>
</div>
